import { useNavigate } from 'react-router-dom'
import { Breadcrumbs as MUIBreadcrumbs, Link, Typography } from '@mui/material'

type BreadcrumbsProps = {
  items: Array<{ label: string; href?: string }>
}
const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { items } = props
  const navigate = useNavigate()

  return (
    <MUIBreadcrumbs aria-label="breadcrumb">
      <Link
        color="inherit"
        component="button"
        onClick={() => navigate('/')}
        sx={{ border: 'none', background: 'none', cursor: 'pointer', textDecoration: 'none' }}
      >
        Home
      </Link>
      {items.map((item) =>
        item.href ? (
          <Link
            color="inherit"
            component="button"
            onClick={() => navigate(item.href!)}
            key={`${item.label}_${item.href}`}
            sx={{ border: 'none', background: 'none', cursor: 'pointer', textDecoration: 'none' }}
          >
            {item.label}
          </Link>
        ) : (
          <Typography color="text.primary" key={`${item.label}_nohref`}>
            {item.label}
          </Typography>
        ),
      )}
    </MUIBreadcrumbs>
  )
}
export default Breadcrumbs
